export default {
  page_title: 'HKLII 簡介',
  t_whatis: "甚麼是 HKLII?",
  t_personnel: '成員',
  t_assist: '對 HKLII 的支援',
  intro: [
    '{0}(HKLII，讀音為 “H K Lee”) 是由香港大學{1}與香港大學{2}在 Australasian Legal Information Institute ({3}) 的協助下共同開發及營運的免費法律資訊系統。',
    'HKLII 旨在透過易於使用且涵蓋範圍廣泛的技術，使大眾能夠獲取免費的第一手法律資訊 (以及一些給予公眾查閱的二手資訊)。HKLII 支持並參與法律信息自由取用運動。',
    'HKLII 提供的資訊來自香港和有關地區。標記及其他技術基礎結構均由 AustLII 提供的軟件而調整。World Law Index 下的香港、中國和台灣頁面（以及某些主題頁面）是由香港大學法律學院和 AustLII 共同編寫。 HKLII 整個項目及日常運作由法律學院管理及負責。',
    '我們希望能為閣下提供有用的法律資訊，亦希望閣下會喜歡使用 HKLII 系統。我們歡迎閣下提供任何鼓勵或建設性批評。',
  ],
  cs_dept: '計算機科學系',
  law_fac: '法律學院',
  law_fac2: '香港大學法律學院',
  addr_tag: '郵寄地址',
  addr: '香港法律資訊中心<br>香港薄扶林道<br>香港大學百周年校園<br>鄭裕彤教學樓10樓<br>',
  email_tag: '電郵',
  email: '請直接於{0}頁面與我們聯繫',
  website_tag: '網址',
  personnel: [
    'HKLII 為{3}{0}和香港大學{1}共同成立的{2}的一個研究項目，由法律學院管理，成立初時亦得到 {4} (AustLII) 的協助。',
    '如閣下對 HKLII 有任何意見或疑問，歡迎於{0}頁面與我們聯繫。'
  ],
  law_and_tech: '資訊科技及法律研究中心',
  uni: '香港大學',
  management_tag: '管理團隊',
  staff_tag: '職員',
  former_staff_tag: '前職員',
  providers_tag: '資料來源',
  providers: [
    'HKLII 的資料庫包含以下數據來源:',
    'HKLII 衷心感謝所有資料提供者。各資料庫頁面上均有註明來源。'
  ],
  provider_ents: [
    '香港特別行政區司法機構',
    '香港特別行政區律政司',
    '香港國際仲裁中心',
    '香港大學呂志和法律圖書館',
    '香港大學法律學院比較法及公法研究中心'
  ],
  grants_tag: '贈款',
  grants: [
    'HKLII 的成立和初期系統維護由香港大學計算機科學系和香港大學法律學院負責，並得到 Australasian Legal Information Institute (AustLII) 的協助及贈款，才得以為大眾提供更多普通法及亞太地區的法律資訊。',
    '我們歡迎閣下查詢有關 HKLII 的贊助和資源。請參閱{0}和{1}頁面以獲取聯絡方法。'
  ],
  thanks_tag: '鳴謝',
  thanks: [
    'HKLII 的成立有賴不同人士的協助和支持，特別是香港特別行政區司法機構及香港特別行政區律政司的人員。由於人數眾多，無法在此一一列出，HKLII 僅此對他們表示衷心謝意。'
  ]
}